/**
 * Masks a person's name for display to someone other than its owner: keeps the
 * first name and the initial of the second word, hides the rest.
 * "Jadhuk Hasan" -> "Jadhuk H***", "Jadhuk Hasan Putra" -> "Jadhuk H***",
 * "Jadhuk" -> "J***", "" -> "".
 *
 * Leading/trailing whitespace is ignored — stored client names sometimes carry it.
 */
export function maskName(name: string): string {
  const [first, second] = name.trim().split(/\s+/).filter(Boolean);
  if (!first) return "";
  if (!second) return `${first[0]}***`;
  return `${first} ${second[0]}***`;
}
